import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { PropertyService } from '../service/property.service';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ToastModule } from 'primeng/toast';

interface IPrompt {
  slug: string;
  content: string;
}

@Component({
  selector: 'app-prompts',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonModule,
    InputTextModule,
    DropdownModule,
    MultiSelectModule,
    FormsModule,
    InputTextareaModule,
    ToastModule
  ],
  templateUrl: './prompts.component.html',
  styleUrls: ['./prompts.component.scss'],
  providers: [MessageService],
})
export class PromptComponent {
  @Output() closeDialog = new EventEmitter<void>();
  selectedPrompt = <IPrompt>{};

  promptForm: FormGroup;
  prompts: any[] = [];

  constructor(
    private fb: FormBuilder,
    private propertyService: PropertyService,
    private messageService: MessageService,
  ) {
    this.promptForm = this.fb.group({
      slug: [{ value: '', disabled: true }],
      content: ['', Validators.required]
    });
  }

  ngOnInit() {
    this.getPrompts();
  }

  getPrompts() {
    this.propertyService.getPrompts().subscribe({
      next: (res) => {
        this.prompts = res;
        console.log(this.prompts);
      },
      error: (err) => console.error('Error fetching prompt', err),
    });
  }

  fillForm() {
    console.log(this.selectedPrompt);
    this.promptForm = this.fb.group({
      slug: [this.selectedPrompt.slug],
      content: [this.selectedPrompt.content]
    });
  }

  async updatePrompt() {
    if (this.promptForm.valid) {
      const data = this.promptForm.value;
      this.propertyService.updatePrompt(data.slug,data).subscribe({
        next: (res:any) => {
          console.log(res);

          if (res?._id) {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Prompt Updated Successfully!',
            });
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Something went wrong!',
            });
          }
        },
        error: (err) => {
          const errorMessage = err?.error?.message || 'Failed to update Prompt!';
          console.log(errorMessage);
        },
      });
    }

  }

}
